import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { routerActions } from 'react-router-redux'

import { userIsAuthenticated } from '../behaviors'

class Logout extends React.Component {
  componentDidMount() {
    this.props.logout()
  }

  render() {
    return null
  }
}

const actions = (dispatch, props) => ({
  logout: async () => {
    await props.firebase.logout()
    dispatch(routerActions.push('/login'))
  },
})

export default compose(
  firebaseConnect(),
  connect(() => ({}), actions),
  userIsAuthenticated()
)(Logout)



// WEBPACK FOOTER //
// ./src/screens/Logout.js